"use strict";

(function (global, factory) {
  factory(require("../froala_3.0.5/js/froala_editor"));
})(void 0, function (FE) {
  "use strict";

  FE = FE && FE.hasOwnProperty("default") ? FE["default"] : FE;

  FE.SelectFroalaText = function (element) {
    if (element.tagName == "P" || element.tagName == "Q" || element.tagName == "ABBR") {
      if (document.selection) {
        var range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
      } else if (window.getSelection()) {
        var range = document.createRange();
        range.selectNode(element);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    }
  };
});